var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCrown = function SvgIconCrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    d: "m22.968 10.177-2.076 9.171a.844.844 0 0 1-.843.667H3.883a.843.843 0 0 1-.843-.667l-2.008-9.17A.844.844 0 0 1 2.23 9.24l4.927 2.387 4.083-7.222a.844.844 0 0 1 1.468 0l4.084 7.23 4.96-2.404a.844.844 0 0 1 1.216.945Z"
  })));
};
export default SvgIconCrown;